import styled, { css } from 'styled-components';

export const CardStyled = styled.div`
  position: relative;
  display: block;

  min-width: 0;
  word-wrap: break-word;
  background-color: ${(p) => p.theme.colors[p.primary ? 'primary90w' : 'white']};
  background-clip: border-box;
  border: ${(p) => (p.primary ? 'none' : `1px solid ${p.theme.colors.secondary90w}`)};
  border-color: ${(p) => (p.selected ? p.theme.colors.primary : p.theme.colors.secondary90w)};
  box-sizing: border-box;
  border-radius: 10px;
  margin-bottom: ${(p) => (p.noMargin ? 0 : '20px')};

  ${(p) =>
    p.fullHeight &&
    css`
      height: calc(100% - 20px);
    `}

  ${(p) =>
    p.fullWidth &&
    css`
      width: 100%;
    `}
`;

export const ContentWrapper = styled.div`
  padding: ${(p) =>
    p.noPadding === 'vertical'
      ? '0 25px'
      : p.noPadding === 'horizontal'
      ? '25px 0'
      : p.noPadding
      ? '0'
      : '25px'};
`;

export const ContentWrapperWithPadding = styled.div`
  padding: ${(p) => (p.onlySide ? '0' : '25px')} 25px;
`;

export const TitlesWrapper = styled.div`
  display: flex;
  flex-direction: column;

  padding: 25px;

  padding-bottom: ${(p) => (p.withBottomPadding ? '25px' : '0')};

  cursor: ${(p) => (p.onClick ? 'pointer' : 'default')};

  border-bottom: ${(p) =>
    !p.withBottomBorder ? 'none' : `1px solid ${p.theme.colors.secondary90w}`};
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const SubTitleWrapper = styled.div``;
